import { L10n } from '../L10n/L10n';
import { IExtractTaskInfo } from '../models/IExtractTaskInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ExtractTasks } from '../resources/ExtractTasks';
import { AbstractContentAction } from './AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import { ContentActionNotification, INotificationTranslationIds } from './ContentActionNotification';

export class RunExtractTasksAction extends AbstractContentAction<IExtractTaskInfo> {

  public static $inject = ['ConfirmActionDialog', 'ContentActionNotification', '$translate', 'ExtractTasks'];

  constructor(
            ConfirmActionDialog: ConfirmActionDialog,
            ContentActionNotification: ContentActionNotification,
    private $translate: ng.translate.ITranslateService,
    private ExtractTasks: ExtractTasks
  ) {
    super(ConfirmActionDialog, ContentActionNotification);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, extractTasks: Set<IExtractTaskInfo>) {
    const extractTaskCount = extractTasks.size();
    if (extractTaskCount === 1) {
      const extractTask = extractTasks.first();
      if (extractTask.datasource) {
        dialogConfig.bodyText = this.$translate.instant('extractTaskForDataSourceRunPrompt', {
          DATASOURCE_NAME: L10n.elideIfLong(extractTask.datasource.name)
        });
      } else if (extractTask.workbook) {
        dialogConfig.bodyText = this.$translate.instant('extractTaskForWorkbookRunPrompt', {
          WORKBOOK_NAME: L10n.elideIfLong(extractTask.workbook.name)
        });
      } else {
        dialogConfig.bodyText = this.$translate.instant('extractTasksRunPrompt', {
          ITEM_COUNT: extractTaskCount
        }, L10n.Interpolations.Count);
      }
    } else {
      dialogConfig.bodyText = this.$translate.instant('extractTasksRunPrompt', {
        ITEM_COUNT: extractTaskCount
      }, L10n.Interpolations.Count);
    }
    dialogConfig.title = this.$translate.instant('runNow');
    dialogConfig.actionName = this.$translate.instant('runNowConfirmButton', {
      ITEM_COUNT: extractTaskCount
    }, L10n.Interpolations.Count);
    dialogConfig.action = () => this.ExtractTasks.run(extractTasks.keys());
  }

  notificationTranslationIds(): INotificationTranslationIds {
    return {
      successId: 'extractTasksRunSuccess',
      errorId: 'extractTasksRunError'
    };
  }

}

Module.instance().service('RunExtractTasksAction', RunExtractTasksAction);
